import React, { useState } from "react";
import { Navigate } from "react-router";
import { withFirebase } from "./context";
import "./signup.css";
import { HOME } from './routes';

export function SignInForm(props) {
  const [authUser, setAuthUser] = useState(props.firebase.auth.currentUser);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleSignIn = async (event) => {
    event.preventDefault();

    if (!email || !password) {
      setErrorMessage('Todos los campos son requeridos.');
      return;
    }

    props.firebase.doSignInWithEmailAndPassword(email, password)
      .then(authUser => {
        //console.log("signedIn: ", authUser);
        setAuthUser(authUser);
      })
      .catch(error => {
        console.log("Error signing in: ", error);
      });
  };

  const handleForgotPassword = async (event) => {
    event.preventDefault();

    props.firebase.doPasswordReset(email);
  }

  const handleSignupWithGoogle = async (event) => {
    event.preventDefault();

    props.firebase.doSignInWithPopup()
      .then(authUser => {
        //console.log("signed up: ", authUser);
        setAuthUser(authUser);
      })
      .catch(error => {
        console.log("Error signing up: ", error);
      });
  }

  return (
    authUser ? <Navigate to={HOME} replace={true} /> :
      <div className="form-container">
        <h2>Ingresar</h2>
        {errorMessage && <p className="error-message">{errorMessage}</p>}
        <form>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              required
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Contraseña</label>
            <input
              type="password"
              id="password"
              name="password"
              required
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </div>
          <div className="form-group">
            <button onClick={handleSignIn} type="button">
              Ingresar
            </button>
          </div>
          <div className="form-group">
            <button disabled={!email} onClick={handleForgotPassword}>Olvidé mi contraseña</button>
          </div>
        </form>
        <hr />
        <div className="form-group">
          <button type="button" onClick={handleSignupWithGoogle}>Ingresar con Google</button>
        </div>
      </div>
  );
}

const SignIn = withFirebase(SignInForm);

export default SignIn;